/**
 * Confirmación de "Cancelar solicitud" (007 · T056; contracts/ui.md §1.5, research R-15, spec
 * US3-5): bottom sheet con el patrón del cierre de sesión de la 006.
 *
 * Explica la consecuencia real antes de confirmar —cancelar cuenta como una de las 3 propuestas
 * (FR-009)—. "Cancelar solicitud" es destructivo; "Volver" (terciario) cierra la hoja sin hacer
 * nada. Mientras se cancela, la hoja no se puede descartar. Un error de red se muestra dentro de la
 * hoja (se puede reintentar); un `409 REGULARIZATION_NOT_OPEN` lo resuelve la sección (cierra la
 * hoja y avisa).
 */
import { REGULARIZATION_MAX_PROPOSALS } from '@fermin/contracts';

import { Button } from '../../components/ui/button';
import { Sheet } from '../../components/ui/sheet';
import { t } from '../../i18n';

export interface CancelSheetProps {
  open: boolean;
  pending: boolean;
  error: string | null;
  onConfirm: () => void;
  onClose: () => void;
}

export function CancelSheet({ open, pending, error, onConfirm, onClose }: CancelSheetProps) {
  return (
    <Sheet
      open={open}
      onClose={onClose}
      dismissible={!pending}
      title={t('regularization.cancelSheet.title')}
      description={t('regularization.cancelSheet.description', {
        max: REGULARIZATION_MAX_PROPOSALS,
      })}
      className="pb-fm-4"
      footer={
        <div data-testid="regularization-cancel-sheet" className="flex flex-col gap-fm-3">
          {error !== null ? (
            <p
              data-testid="regularization-cancel-error"
              role="alert"
              className="text-fm-base text-fm-danger-text"
            >
              {error}
            </p>
          ) : null}
          <Button
            data-testid="regularization-cancel-confirm"
            variant="destructive"
            onClick={onConfirm}
            loading={pending}
            loadingText={t('regularization.cancelSheet.processing')}
          >
            {t('regularization.cancelSheet.confirm')}
          </Button>
          <Button variant="ghost" onClick={onClose} disabled={pending}>
            {t('regularization.cancelSheet.back')}
          </Button>
        </div>
      }
    />
  );
}
